import { ContactOption, ContactUs, Offices } from "@kunduz/ui-components";
import React, { ReactElement } from "react";
import { getCmsIcon } from "../static/iconMappings";

export const DynamicContactUs = (props: Props): ReactElement => {
  function prepareLink(type?: string, value?: string): string {
    if (!type || !value) return "#";
    if (type === "link") {
      return value;
    } else {
      return `${type}:${value}`;
    }
  }

  if (props.image) {
    return (
      <Offices
        title={props.title}
        badgeText={props.badge_text}
        badgeIcon={props.badge_icon}
        desc={props.description}
        imageUrl={props.image}
        locations={props.items?.map((x) => ({
          desc: x.description,
          title: x.title,
          flag: x.image,
        }))}
      />
    );
  } else {
    return (
      <ContactUs
        title={props.title}
        badgeText={props.badge_text}
        badgeIcon={props.badge_icon}
        desc={props.description}
      >
        {props.items?.map((item, index) => (
          <ContactOption
            key={`contact_option_${index}`}
            icon={getCmsIcon(item.icon)}
            title={item.title}
            desc={item.description}
            value={item.communication_text}
            href={prepareLink(item.communication_type, item.communication_text)}
          />
        ))}
      </ContactUs>
    );
  }
};

interface Props {
  title: string;
  description: string;
  image?: string;
  badge_text?: string;
  badge_icon?: React.ElementType;
  items?: {
    title: string;
    description: string;
    image?: string;
    icon?: string;
    communication_type?: string;
    communication_text?: string;
  }[];
}
